module.exports = __webpack_public_path__ + "img/corner-mezzanine.987db1f3.svg";